export enum RentOptionStatus {
  open = 1,
  closed = 2,
  obsolete = 3
}
